import { useGetList, useGetOne } from 'react-admin';

export const MEDICAL_RECORDS_REQUESTS_QUERY = 'medical-records-requests';

export function useAllMedicalRecordsRequests(
  { petId, claimId },
  params = {},
  options = {}
) {
  const filter = { pet_id: petId };
  if (claimId) filter.claim_submission_id = claimId;

  return useGetList(
    MEDICAL_RECORDS_REQUESTS_QUERY,
    {
      pagination: { page: 1, perPage: 25 },
      sort: { field: 'created_at', order: 'DESC' },
      filter: filter,
      ...params,
    },
    {
      ...options,
      keepPreviousData: true,
      enabled:
        typeof options.enabled === 'boolean' ? options.enabled && !!petId : !!petId,
    }
  );
}

export function useMedicalRecordsRequest(id, options = {}) {
  return useGetOne(
    MEDICAL_RECORDS_REQUESTS_QUERY,
    { id: id },
    {
      ...options,
      enabled: typeof options.enabled === 'boolean' ? options.enabled && !!id : !!id,
    }
  );
}
